import { finalizeLoginSession } from "../../api/client";

export async function completeAdminLogin(
  em,
  response,
  loginData,
  remember,
  navigate,
  location,
  password = null
) {
  await finalizeLoginSession({
    email: em,
    password,
    loginResponse: response,
    loginPayload: loginData,
    remember,
    requireCredentials: true,
  });

  const storage = remember ? localStorage : sessionStorage;
  const otherStorage = remember ? sessionStorage : localStorage;
  storage.setItem("ds_isAuthed", "1");
  storage.setItem("ds_portal", "admin");
  otherStorage.removeItem("ds_isAuthed");
  otherStorage.removeItem("ds_portal");

  const next = location.state?.from || "/admin";
  navigate(next, { replace: true });
}
